var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-background"},[_c('div',{staticClass:"row align-items-end"},[_c('img',{staticClass:"col-sm-6 img-pos",attrs:{"src":require("../../assets/UT_Logo_2400_Sta_White_EN.png"),"width":"50%","alt":"UTLogo"}})])])
}]

export { render, staticRenderFns }